export const isMobile = (): boolean =>
  [/mobile/i, /Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /BB10/i, /phone/i].some(regex =>
    window?.navigator?.userAgent.match(regex),
  );
